module.exports = __webpack_public_path__ + "img/evmos-small-light.bec2a515.svg";